import { render } from "./TheNavigation3.vue?vue&type=template&id=383a4819"
import script from "./TheNavigation3.vue?vue&type=script&lang=js"
export * from "./TheNavigation3.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\svila\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__